/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const CredentialProof: core.serialization.ObjectSchema<
    serializers.CredentialProof.Raw,
    Truvity.CredentialProof
> = core.serialization.object({
    id: core.serialization.string().optional(),
    type: core.serialization.string(),
});

export declare namespace CredentialProof {
    export interface Raw {
        id?: string | null;
        type: string;
    }
}
